// components/TipoSelecao.tsx
import React from 'react';

interface TipoSelecaoProps {
  selecionado: string;
  onChange: (valor: string) => void;
}

export const TipoSelecao: React.FC<TipoSelecaoProps> = ({
  selecionado,
  onChange,
}) => {
  const handleChange = (valor: string) => {
    onChange(valor === selecionado ? '' : valor);
  };

  return (
    <div className="flex flex-row gap-20 p-6">
      <div className="w-50 relative flex gap-2">
        <label
          htmlFor="checkbox1"
          className="relative h-6 w-6 flex items-center justify-center overflow-hidden rounded-full bg-gradient-to-tr from-[#4158D0] via-[#131446] to-[#ffcd7065] p-1 duration-100 hover:p-1.5 cursor-pointer"
        >
          <input
            type="checkbox"
            className="peer hidden"
            id="checkbox1"
            checked={selecionado === 'empresarial'}
            onChange={() => handleChange('empresarial')}
          />
          <div className="absolute left-[0.47rem] h-[3px] w-[14px] -translate-y-8 translate-x-8 rotate-[-71deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
          <div className="absolute left-1 top-[0.87rem] h-[3px] w-[10px] -translate-x-8 -translate-y-8 rotate-[25deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
        </label>
        <span>
          <strong className="text-red-500 text-1xl p-1">*</strong>
          Empresarial
        </span>
      </div>

      <div className="w-50 relative flex gap-2">
        <label
          htmlFor="checkbox2"
          className="relative h-6 w-6 flex items-center justify-center overflow-hidden rounded-full bg-gradient-to-tr from-[#4158D0] via-[#131446] to-[#ffcd7065] p-1 duration-100 hover:p-1.5 cursor-pointer"
        >
          <input
            type="checkbox"
            className="peer hidden"
            id="checkbox2"
            checked={selecionado === 'administradora'}
            onChange={() => handleChange('administradora')}
          />
          <div className="absolute left-[0.47rem] h-[3px] w-[14px] -translate-y-8 translate-x-8 rotate-[-71deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
          <div className="absolute left-1 top-[0.87rem] h-[3px] w-[10px] -translate-x-8 -translate-y-8 rotate-[25deg] rounded-sm bg-white duration-300 peer-checked:translate-x-0 peer-checked:translate-y-0"></div>
        </label>
        <span>
          <strong className="text-red-500 text-1xl p-1">*</strong>
          Administradora
        </span>
      </div>
    </div>
  );
};
